import { HttpMethod, initFetch } from "../../utils/fetcher";
import {
  adaptedToQualite,
  qualitesToAdapted,
  qualiteToAdapted,
} from "../../adapter/qualiteAdapter";

export const LOAD_SUCCESS_QUALITES = "LOAD_SUCCESS_QUALITES";
export const LOAD_FAIL_QUALITES = "LOAD_FAIL_QUALITES";
export const SAVE_SUCCESS_QUALITES = "SAVE_SUCCESS_QUALITES";
export const SAVE_FAIL_QUALITES = "SAVE_FAIL_QUALITES";
export const UPDATE_SUCCESS_QUALITES = "UPDATE_SUCCESS_QUALITES";
export const UPDATE_FAIL_QUALITES = "UPDATE_FAIL_QUALITES";
export const DELETE_SUCCESS_QUALITES = "DELETE_SUCCESS_QUALITES";
export const DELETE_FAIL_QUALITES = "DELETE_FAIL_QUALITES";

export function loadQualites() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`qualites`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.qualite);
          dispatch({
            type: LOAD_SUCCESS_QUALITES,
            payload: qualitesToAdapted(res.qualite),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_QUALITES,
            error: err,
          });
        });
    });
  };
}

export function saveQualite(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`qualites`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToQualite(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.qualite);
          dispatch({
            type: SAVE_SUCCESS_QUALITES,
            payload: qualiteToAdapted(res.qualite),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_QUALITES,
            error: err,
          })
        );
    });
  };
}

export function updateQualite(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`qualites/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToQualite(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.qualite);
          dispatch({
            type: UPDATE_SUCCESS_QUALITES,
            payload: qualiteToAdapted(res.qualite),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_QUALITES,
            error: err,
          })
        );
    });
  };
}

export function deleteQualite(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`qualites/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.qualite);
          dispatch({
            type: DELETE_SUCCESS_QUALITES,
            payload: qualiteToAdapted(res.qualite),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_QUALITES,
            error: err,
          });
        });
    });
  };
}
